import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Loader2, ArrowLeft } from 'lucide-react';

const Login = () => {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);
    
    if (!result.success) {
      setError(result.error);
    }
    
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9FAFB] p-4">
      <Card className="w-full max-w-md border border-gray-200 bg-white" data-testid="login-card">
        <CardHeader className="text-center space-y-4">
          <Link to="/" className="inline-flex items-center text-gray-500 hover:text-gray-700 text-sm mb-2">
            <ArrowLeft size={16} className="mr-1" />
            Voltar ao site
          </Link>
          <div className="mx-auto">
            <img src="/logo-full.png" alt="Tenance" className="h-16 mx-auto" />
          </div>
          <div>
            <CardTitle className="text-2xl" style={{ fontFamily: 'Work Sans' }}>
              Área Administrativa
            </CardTitle>
            <CardDescription className="mt-2">
              Faça login para acessar o sistema de gestão
            </CardDescription>
          </div>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            {error && (
              <div 
                className="p-3 bg-red-50 border border-red-200 text-red-700 text-sm rounded-lg"
                data-testid="login-error"
              >
                {error}
              </div>
            )}
            
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                placeholder="seu@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="login-email-input"
                className="h-11 bg-white"
              />
            </div>
            
            <div className="space-y-2">
              <Label htmlFor="password">Senha</Label>
              <Input
                id="password"
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="login-password-input"
                className="h-11 bg-white"
              />
            </div>
            
            <Button 
              type="submit" 
              className="w-full h-11 bg-[#2B7A3D] hover:bg-[#236331] text-white"
              disabled={loading}
              data-testid="login-submit-btn"
            >
              {loading ? (
                <>
                  <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                  Entrando...
                </>
              ) : (
                'Entrar'
              )}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default Login;
